// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"py_a","ListOfForumsRight__brandDaysPosts":"py_b bhe_su"};